import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function MainsPage() {

    const heroData = [
        {
          title: "Mains",
          content: "Savor the smoky aroma of our grills, offering a range of succulent meats, seafood, and vegetables. Expertly marinated and cooked to perfection, they are a feast for the senses.",
          image: images.GrillsHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Grilled Chicken",
        content: "With creamy Mushroom sauce",
        price: 0,
        image: [
          images.Grill1,
        ]
      },
      {
        name: "Fillet Mignon",
        content: "Chimichurri sauce",
        price: 0,
        image: [
          images.Grill2,
        ]
      },
      {
        name: "Grilled Salmon",
        content: "With lemon cream sauce",
        price: 0,
        image: [
          images.Grill3,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Grilled Chicken",
        image1: [
          images.Grill1,
        ],
        content1: "With creamy Mushroom sauce",
        name2: "Fillet Mignon",
        image2: [
          images.Grill2,
        ],
        content2: "Chimichurri sauce"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
